export function getDataFromScope(coursewareItemId, scope = []) {
  const coursewareItemScope = scope.find(
    (item) => (item.sourceId === coursewareItemId)
  ) || {};
  const { scopeURN, data } = coursewareItemScope;
  if (data) {
    return {
      scopeURN,
      scopeData: data ? JSON.parse(data) : {},
    };
  }
  return {};
}
